import {autorun, makeAutoObservable} from "mobx";
import {resources} from "../resources";
import {fancyAlert} from "./alert";
import {connection} from "./connection";
import {occupancyModel} from "./occupancy";
import {CubeResponse} from "./types";

class CubeModel {
	constructor() {
		makeAutoObservable(this);
	}

	cubes: CubeResponse[] = [];

	async addCubeByLocation(position: GeolocationPosition) {
		await this.addCube(await connection.addCubeByLocation(position.coords));
	}

	async getLocationCodeShape() {
		return await connection.getLocationCodeShape();
	}

	async getCubeByCode(code: string) {
		return await connection.getCubeByCode(code);
	}

	async addCubeByCode(code: string) {
		await this.addCube(await connection.getCubeByCode(code));
	}

	private async addCube(cube: CubeResponse) {
		// if we already have an occupancy at that cube, we untrack from it
		// to avoid automatic occupation later
		if (occupancyModel.hasOccupancyAtCube(cube.hostname)) {
			await this.remove(cube.hostname);
			fancyAlert(resources.strings.AlreadyHaveOccupancy);
		}
		else if (!this.cubes.filter(existing => existing.hostname == cube.hostname).pop()) {
			this.cubes.push(cube);
		}
	}

	async remove(hostname: string) {
		console.log("removing cube", hostname);
		this.cubes = await connection.removeCube(hostname);
	}

	async fetch() {
		try {
			this.cubes = await connection.fetchCubes();
		}
		catch (error) {
			console.error("Error while fetching cubes", error);
			throw error;
		}
	}

	addCubeByDeviceLocation() {
		return new Promise((resolve, reject) => {
			const handleLocationReceived = async (position: GeolocationPosition) => {
				console.info("Retrieved geolocation", position);
				try {
					await this.addCubeByLocation(position);
					resolve("");
				}
				catch (error) {
					console.error("Error while adding location", error);
					reject(error);
				}
			};

			const handleLocationError = (error: GeolocationPositionError) => reject(error);

			console.info("Requesting geolocation");
			if (navigator.geolocation && navigator.geolocation.getCurrentPosition) {
				navigator.geolocation.getCurrentPosition(handleLocationReceived, handleLocationError, {
					enableHighAccuracy: true,
					maximumAge: 10000,
				});
			}
		});
	}
}

export const cubeModel = new CubeModel();

autorun(() => console.log("cubes", cubeModel.cubes.map(cube => cube.name)));
